(() => {
 const fine = window.matchMedia('(hover:hover) and (pointer:fine)');
 const stop = video => { video.pause(); video.removeAttribute('data-playing'); try { video.currentTime = 0; } catch {} };
 document.addEventListener('pointerover', event => {
  const card = event.target.closest('.card-image');
  if (!card || card.contains(event.relatedTarget) || !fine.matches || event.pointerType === 'touch') return;
  const video = card.querySelector('.hover-video');
  if (video) video.play().then(() => { if (card.matches(':hover') && fine.matches) video.setAttribute('data-playing', ''); else stop(video); }).catch(() => stop(video));
 });
 document.addEventListener('pointerout', event => {
  const card = event.target.closest('.card-image');
  if (!card || card.contains(event.relatedTarget)) return;
  const video = card.querySelector('.hover-video'); if (video) stop(video);
 });
 document.addEventListener('error', event => {
  if (event.target.matches?.('.hover-image,.hover-video')) event.target.style.display = 'none';
 }, true);
 fine.addEventListener('change', () => document.querySelectorAll('.hover-video').forEach(stop));
 document.addEventListener('visibilitychange', () => { if (document.hidden) document.querySelectorAll('.hover-video').forEach(stop); });
})();
